import requestMethods from '@/helpers/request/requestMethods';
import { likeApiConfig } from '@/constants/ApiUrls';

function like({ objectType, objectId, data = {} }) {
    return requestMethods.post({
        routeConfig: likeApiConfig(objectType, objectId),
        data
    });
}

function unlike({ objectType, objectId, data = {} }) {
    return requestMethods.del({
        routeConfig: likeApiConfig(objectType, objectId),
        data
    });
}

export { like, unlike };
